import React from 'react';
import { useTranslation } from 'react-i18next';
import ResponsePageWrapper from '../../components/layouts/ResponsePageWrapper';
import Button from '../../components/misc/Button';
import {
  CrmInviteData,
  ExternalMemberInviteData,
  NetworkInviteLinkModel,
  NetworkInviteModel,
} from '../../types/invites';
import { CommunityOverview } from '../../components/misc/CommunityOverview';
import { EventParticipationAnswer, PersonalEvent } from '../../types/event';
import AttendanceComponent from '../../components/misc/AttendanceComponent';

interface CommunityInvitePageProps {
  invite: NetworkInviteModel | NetworkInviteLinkModel | ExternalMemberInviteData | CrmInviteData;
  onSubmit: () => void;
  event?: PersonalEvent | null;
  eventAnswer?: EventParticipationAnswer | null;
  onEventAnswerChange?: ((answer: EventParticipationAnswer) => void) | null;
}

export default function NoRequestedDataCommunityInvitePage({
  invite,
  onSubmit,
  event,
  eventAnswer,
  onEventAnswerChange,
}: CommunityInvitePageProps): JSX.Element {
  const { t } = useTranslation();
  const { name } = invite;

  return (
    <ResponsePageWrapper>
      <ResponsePageWrapper.SidePanel>
        <CommunityOverview invite={invite} />
      </ResponsePageWrapper.SidePanel>
      {event && onEventAnswerChange && (
        <div className="bg-secondary-10 mt-4 rounded-lg border border-secondary-50 p-4">
          <h2 className="mb-2 text-lg font-medium">{t('page.events.infoScreen.attendance.title')}</h2>
          <p className="mb-2 text-lg">{event.title}</p>
          <p className="text-md mb-4">{t('page.events.infoScreen.attendance.question')}</p>
          <AttendanceComponent selectedAnswer={eventAnswer ?? null} setSelectedAnswer={onEventAnswerChange} />
        </div>
      )}
      <div className="flex h-full flex-1 flex-col gap-4">
        <div className="flex flex-col gap-2">
          <h2 className="mb-4 text-2xl font-semibold">
            {t('page.noRequestedDataCommunityInvitePage.title', { name })}
          </h2>
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-sm">{t('page.noRequestedDataCommunityInvitePage.subtitle', { name })}</p>
        </div>

        <div className="flex h-full min-h-10 flex-1 items-end justify-end gap-2 align-bottom">
          <Button variant="primary" className="px-[32px]" onClick={onSubmit}>
            {t('page.noRequestedDataCommunityInvitePage.submit', { name })}
          </Button>
        </div>
      </div>
    </ResponsePageWrapper>
  );
}
